/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_ChooseInputs */

const en_road_dude_prompt_choose = /** @type {(inputs: Road_Dude_Prompt_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who’s driving?`)
};

const zh_road_dude_prompt_choose = /** @type {(inputs: Road_Dude_Prompt_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`谁来开车？`)
};

/**
* | output |
* | --- |
* | "Who’s driving?" |
*
* @param {Road_Dude_Prompt_ChooseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_choose = /** @type {((inputs?: Road_Dude_Prompt_ChooseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_ChooseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_choose(inputs)
	return zh_road_dude_prompt_choose(inputs)
});
export { road_dude_prompt_choose as "road_dude.prompt.choose" }